import styled from 'styled-components';
import { Table, Tabs } from 'antd';

export const StyledTab = styled(Tabs)`
  background: white;
  .ant-tabs-nav {
    margin-bottom: 0px;
    padding-left: 30px;
  }
  .ant-tabs-tabpane {
    background-color: #f2f4f6;
  }
`;

export const StyledTabBarExtraContent = styled.div`
    display: flex;
    align-items: center
    font-weight: 500;
    margin-right: 32px;
    .ant-switch {
        margin-left: 8px;
    }
`;

export const Container = styled.div`
  margin: 20px;
  padding: 20px;
  border-radius: 4px;
  background-color: white;
`;

export const StyledTable = styled(Table)`
  &&& {
    .ant-table-cell {
      padding: 6px 0 !important;
      max-height: 50px;
      height: 50px;
      border: 1px solid #d9d9d9d1;
    }
    td {
      background: #fff;
    }
  }
`;
